// Notification-preference function handles (bead hf-e7-notifications-742.3).
//
// Same shape as ./plan.ts and ./circleSettings.ts: named handles re-exporting the
// generated api, with result types inferred by `FunctionReturnType` so the browser
// cannot drift from the backend. The feature module imports only the TYPES.

import type { FunctionReturnType } from "convex/server";

import { api } from "../../../../convex/_generated/api";

/**
 * What this member has chosen, and what they are ALLOWED to choose.
 *
 * `plan.view`-gated on the server, which is the right level: deciding how you are
 * personally contacted is not a privilege. The view carries the rules as well as the
 * values, so the surface can explain an unmutable category rather than render a switch
 * that is off and disobeyed.
 */
export const notificationPreferencesQuery = api.domain.notifications.myNotificationPreferences;

export const setNotificationPreferencesMutation =
  api.domain.notifications.setMyNotificationPreferences;

/** NTF-018's visible circle policy. `plan.manage` on the server, never inferred here. */
export const setCircleQuietHoursOverrideMutation =
  api.domain.notifications.setCircleQuietHoursOverride;

export type NotificationPreferencesResult = FunctionReturnType<typeof notificationPreferencesQuery>;
export type SetNotificationPreferencesOutcome = FunctionReturnType<
  typeof setNotificationPreferencesMutation
>;
export type SetCircleQuietHoursOverrideOutcome = FunctionReturnType<
  typeof setCircleQuietHoursOverrideMutation
>;
